import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import icons1 from "../../../Assets/UserSide/head.svg";
import icons2 from "../../../Assets/UserSide/email.svg";
import icons3 from "../../../Assets/UserSide/call.svg";
import img1 from "../../../Assets/UserSide/TouchUsBackground.png";
const TouchWithUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS with a duration of 1000ms
  }, []);

  return (
    <div>
      <div className="mt-10 py-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mx-4 md:mx-16">
          <div data-aos="fade-right">
            <iframe
              src="https://www.google.com/maps?q=H-76,+Kalinga+Nagar,+Bhubaneswar&output=embed"
              allowFullScreen=""
              className="w-full h-full"
              loading="lazy"
            ></iframe>
          </div>
          <div data-aos="fade-left">
            <h2 className="text-xl md:text-2xl font-bold mb-4">
              Get In Touch With Us
            </h2>
            <p className="text-gray-600 text-sm md:text-base mb-6">
              We'd love to hear from you! Whether you have questions about our
              treatments, want to book an appointment, or need assistance with
              anything else, our team is here to help.
            </p>
            <div
              className="flex items-center mb-4"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <img src={icons1} alt="icons" />
              <div className="ml-4">
                <h3 className="text-sm md:text-lg font-semibold">
                  HEAD OFFICE
                </h3>
                <p className="text-gray-700 text-xs md:text-sm ">Bhubaneswar</p>
              </div>
            </div>
            <div
              className="flex items-center mb-4"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <img src={icons2} alt="icons" />
              <div className="ml-4">
                <h3 className="text-sm md:text-lg font-semibold">
                  EMAIL SUPPORT
                </h3>
                <p className="text-gray-700 text-xs md:text-sm">
                  hello.yostel@gmail.com
                </p>
              </div>
            </div>
            <div
              className="flex items-center"
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <img src={icons3} alt="icons" />
              <div className="ml-4">
                <h3 className="text-sm md:text-lg font-semibold">LET'S TALK</h3>
                <p className="text-gray-700 text-xs md:text-sm">
                  +91 8328991641
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TouchWithUs;
